/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

import React from 'react';
import { cloneDeep } from 'lodash';

import { Icon, Label, HasPermission } from '@fitinsur/components'
import { events } from '../events/index';
import * as S from './styles';

function renderSectionTotals({
  questionnaire,
  economicGroup,
  setEconomicGroup,
  referenceDate,
  matchParamsIdOperation,
  operation,
  economicGroupTotals
}) {
  const isEconomicGroup = questionnaire.find(qst => qst.idQuestion === 1830)?.idAnswerOption === 7415;

  return (
    <S.TotalContainer>
      <S.LabelGroup width="55px" tabletWidth="50%">
        <Label fontSize={16}>Total</Label>
      </S.LabelGroup>

      <S.LabelGroup width="7%" tabletWidth="50%" />
      <S.LabelGroup width="8%" tabletWidth="50%" />
      <S.LabelGroup width="8%" tabletWidth="50%" />
      <S.LabelGroup width="7%" tabletWidth="50%" />

      <S.LabelGroup width="8%" tabletWidth="30%">
        <Label fontSize={14}>{
          economicGroupTotals.approvedLimitValue.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
        }</Label>
      </S.LabelGroup>
      <S.LabelGroup width="8%" tabletWidth="30%">
        <Label fontSize={14}>{
          economicGroupTotals.currentExposureValue.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
        }</Label>
      </S.LabelGroup>
      <S.LabelGroup width="8%" tabletWidth="30%">
        <Label fontSize={14}>{
          economicGroupTotals.draftedValue.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
        }</Label>
      </S.LabelGroup>
      <S.LabelGroup width="7%" tabletWidth="30%">
        <Label fontSize={14}>{
          economicGroupTotals.economicGroupCapacityValue.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
        }</Label>
      </S.LabelGroup>

      <S.LabelGroup width="7%" tabletWidth="30%" />
      <S.LabelGroup width="9%" tabletWidth="30%" />

      <S.LabelGroup width="5%" tabletWidth="50%" />
      <S.LabelGroup width="7%" tabletWidth="50%" />

      {[416, 417, 418, 425].includes(operation?.idDomainStatus) && (
        <div style={{ width: "100px", display: "flex" }}>
          {isEconomicGroup && (
            <S.IconButton
              onClick={(e) => {       
                economicGroup.map((group) => {
                  if (group.economicGroupRelationships.find(relationship => relationship.isHead && relationship.idOperation === matchParamsIdOperation)) {
                    const newRow = events.createSectionRow({ group: group.economicGroupRelationships, isHead: false, referenceDate });
                    
                    group.economicGroupRelationships = [...group.economicGroupRelationships, newRow];
                  }
                });
                setEconomicGroup(economicGroup);
              }}
            >
              <Icon name="plus" style={{ margin: 0 }} />
            </S.IconButton>
          )}
        </div>
      )}
    </S.TotalContainer>
  )
}

function renderSectionExtraButtons({
  questionnaire,
  economicGroup,
  setEconomicGroup,
  sectionIndex,
  groupIndex,
  economicGroupToDelete,
  setEconomicGroupToDelete,
  idOperation,
  matchParamsIdOperation = null,
  history,
  modalEconomicGroup,
  setModalEconomicGroup,
  referenceDate,
  setDialog,
  handleConfirmationRemovalBorrowerFromEconomicGroup,
  operation
}) {

  const economicGroupFound = economicGroup[sectionIndex].economicGroupRelationships[groupIndex];
  const groupContext = economicGroup[sectionIndex];

  const groupOperationId = economicGroupFound?.idOperation;
  const personRelationshipExpireDate = economicGroupFound?.personRelationshipExpireDate;
  const memberOfEconomicGroup = economicGroupFound?.memberOfEconomicGroup;
  const questions = cloneDeep(economicGroupFound?.questions) ?? [];
  const isEconomicGroup = questionnaire.find(qst => qst.idQuestion === 1830)?.idAnswerOption === 7415;
  const isProject = questionnaire.find(qst => qst.idQuestion === 1723)?.idAnswerOption === 7336;

  const group = cloneDeep(economicGroup[0]);

  return (
    <div style={{ width: "100px", display: "flex", alignItems: 'center' }}>
      <HasPermission permission={matchParamsIdOperation == idOperation && isEconomicGroup && economicGroup[sectionIndex].contextHierarchyChildren && !economicGroupFound.isNew}>
        <S.IconButton type='button'>
          <Icon
            name="info-border-sompo"
            title="Extrato do Grupo Econômico"
            onClick={(e) => {
              e.stopPropagation();
              setModalEconomicGroup(idOperation);
            }}/>
        </S.IconButton>
      </HasPermission>
      <HasPermission permission={(memberOfEconomicGroup || personRelationshipExpireDate) && !economicGroupFound.isHead}>
        <S.IconButton
          style={{ marginBottom: '10px' }}
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            setDialog && setDialog({
              show: true,
              title: 'Detalhe grupo econômico',
              questions: questions.map(qst => {
                qst.visibleQuestion = [1837, 1694, 2005, 2006].includes(qst.idQuestion);
                qst.behaviorObject.desktopWidth = 50;
                return qst;
              })
            })
          }}
        >
          <Icon name="vertical-three-dots" title="Informações adicionais" style={{ margin: 0 }} />
        </S.IconButton>
      </HasPermission>

      <HasPermission permission={groupOperationId && !personRelationshipExpireDate && !economicGroupFound.isHead}>
        <S.IconButton
            style={{ marginBottom: '10px' }}
          >
            <Icon
              name="edit"
              title="Editar Análise"
              onClick={() => {
                history.push(`/credit-analysis/edit/57/${groupOperationId}`)
                window.location.reload();
              }}
              style={{ margin: 0 }}
            />
          </S.IconButton>
      </HasPermission>


      <HasPermission permission={!personRelationshipExpireDate && economicGroupFound.type !== 'P' && idOperation != matchParamsIdOperation && economicGroup[sectionIndex].contextHierarchyChildren && [416, 417, 418, 425].includes(operation?.idDomainStatus)}>
        <S.IconButton
          style={{ marginBottom: '10px' }}

          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            if (handleConfirmationRemovalBorrowerFromEconomicGroup) {
              handleConfirmationRemovalBorrowerFromEconomicGroup(() => {
                if (!economicGroupFound?.isNew) {
                  setEconomicGroupToDelete([...economicGroupToDelete, economicGroupFound]);
                }
                setEconomicGroup(economicGroup.map((groups) => {
                  return ({...groups, economicGroupRelationships: groups.economicGroupRelationships.filter((group) => group !== economicGroupFound
                  )});
                }));
              });
            }
          }}
        >
          <Icon name="trash" style={{ margin: 0 }} />
        </S.IconButton>
      </HasPermission>

      <HasPermission permission={!isEconomicGroup &&
      !personRelationshipExpireDate &&
      (groupContext?.contextHierarchyChildren || groupContext?.contextHierarchyParent) &&
      !isProject &&
      ![416, 417,419,425].includes(operation.idDomainStatus)}>
        <S.IconButton
          style={{ marginBottom: '10px' }}
          onClick={(e) => {
            economicGroup[sectionIndex].economicGroupRelationships[groupIndex] = events.createSectionRow({ group: [economicGroupFound], isHead: true, referenceDate });
            
            setEconomicGroup(economicGroup);
            setEconomicGroupToDelete([...economicGroupToDelete, economicGroupFound]);
          }}
        >
          <Icon name="economic-group" style={{ margin: 0 }} />
        </S.IconButton>
      </HasPermission>
    </div>
  )
}

function renderSectionExtraLeftChildren({ type }) {
  return (
    <div style={{ alignSelf: "end", marginBottom: "25px", marginRight: "15px" }}>
      {type === "E" && <Icon name='letra-e' title='Empresa' />}
      {type === "P" && <Icon name='letra-p' title='Projeto' />}
      {!type && <div style={{ width: "35px" }}></div>}
    </div>
  )
}

const components = {
  renderSectionTotals,
  renderSectionExtraButtons,
  renderSectionExtraLeftChildren
}

export { components }
